<template>
  <!-- Desktop / modal presentation: left-aligned title with optional back button -->
  <div
    v-if="!useMobileLayout"
    class="mb-[18px] flex w-full items-center font-primary text-[17px] font-semibold leading-[24px] text-gray-800"
  >
    <Icon
      v-if="showBack"
      :size="26"
      name="ChevronUp"
      class="mr-2 cursor-pointer stroke-gray-800 -rotate-90 mt-0.5 -ml-1.5"
      @click="handleBack"
    />
    <slot />
  </div>
  <!-- Mobile bottom sheet: centered title -->
  <div
    v-else
    class="flex w-full items-center justify-between border-b border-[#EFEFEF] p-4 font-secondary text-[16px] leading-[22px] text-gray-800"
  >
    <div class="min-w-[60px]">
      <div
        v-if="showBack"
        class="flex items-center cursor-pointer"
        @click="handleBack"
      >
        <Icon
          :size="25"
          name="ChevronUp"
          class="stroke-gray-800 -rotate-90 -ml-2"
        />
        <div class="font-secondary">Back</div>
      </div>
      <slot v-else name="left" />
    </div>
    <div class="w-full text-center font-medium"><slot /></div>
    <div class="min-w-[60px] text-right flex justify-end font-secondary">
      <slot name="right" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, type ComputedRef } from 'vue'
import { Icon } from '@dacr/ui'
import { useDevice } from '@/shared/composables/useDevice'
import { useDialog } from './useDialog'

const props = defineProps<{
  onBack?: () => void
}>()

const { isMobile } = useDevice()
const { close } = useDialog()

const dialogIndex = inject<number>('dialogIndex', 0)
const isModal = inject<boolean>('dialogModal', false)
const hideCloseButton = inject<ComputedRef<boolean>>(
  'dialogHideCloseButton',
  computed(() => false)
)
const showBack = computed(() => dialogIndex > 0 && !hideCloseButton.value)
const useMobileLayout = isMobile.value && !isModal

const handleBack = () => {
  if (props.onBack) {
    props.onBack()
  } else {
    close()
  }
}
</script>
